import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import SitePairingEmbedComponent from './site-pairing-embed';

@NgModule({
    declarations: [
        SitePairingEmbedComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule
    ],
    providers: [

    ],
    exports: [
        SitePairingEmbedComponent
    ]
})

export class SitePairingModule {
}



// WEBPACK FOOTER //
// ./src/app/components/sitepairing/site-pairing.module.ts